import { render, staticRenderFns } from "./DropdownCounter.vue?vue&type=template&id=51ed33bb&scoped=true"
import script from "./DropdownCounter.vue?vue&type=script&lang=js"
export * from "./DropdownCounter.vue?vue&type=script&lang=js"
import style0 from "./DropdownCounter.vue?vue&type=style&index=0&id=51ed33bb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ed33bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ed33bb')) {
      api.createRecord('51ed33bb', component.options)
    } else {
      api.reload('51ed33bb', component.options)
    }
    module.hot.accept("./DropdownCounter.vue?vue&type=template&id=51ed33bb&scoped=true", function () {
      api.rerender('51ed33bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/DropdownCounter.vue"
export default component.exports